import styled from "styled-components";
import { MainBox } from "../../theme/global.styles";

export const CMStatisticsAnalytics = styled.div((props) => ({
  fontWeight: 500,
  fontFamily: props.theme.fontFamilies.workSans,

  // '& .accordion-title': {
  //     paddingBottom: 0
  // },

  ".MuiPaper-root": {
    boxShadow: "unset",

    "& .MuiAccordionSummary-root, & .MuiAccordionDetails-root": {
      padding: 0,
    },

    "& .MuiAccordionDetails-root": {
      [`& ${MainBox}`]: {
        // paddingTop: 0,
        paddingBottom: "20px",
      },
    },
  },
}));

export const CMSocialImpact = styled.div((props) => ({
  "& > div": {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "3rem",
  },

  "& h4": {
    [`@media (min-width: 2000px)`]: {
      fontSize:"3vh",
    },
  },

  "& p": {
    [`@media (min-width: 2000px)`]: {
      fontSize:"2.5vh",
    },
  },

  "& .CMImageSize": {
    width: "100%"
  },

  /*"& select": {
    minWidth: "300px",
    minHeight: "30px",
  },*/
  [`@media ${props.theme.breakpoints.lg}`]: {
    "& .CMImageSize": {
      width: "100%",
    },
    "& > div": {
      gridTemplateColumns: "repeat(3, 1fr) !important",
    },
  },
  [`@media ${props.theme.breakpoints.md}`]: {
    "& > div": {
      gridTemplateColumns: "repeat(2, 1fr) !important",
    },
  },

  [`@media ${props.theme.breakpoints.sm}`]: {
    "& > div": {
      gridTemplateColumns: "repeat(1, 1fr) !important",
    },
  },
  [`@media ${props.theme.breakpoints.xs}`]: {
    "& > div": {
      gridTemplateColumns: "repeat(1, 1fr) !important",
    },
  },
}));

export const CMSocialImpactItem = styled.div((props) => ({
  "& .social-media-title": {
    display: "flex",
    padding: "5px 0",
    alignItems: "center",
    borderBottom: `solid 2px ${props.theme.palette.gray["700"]}`,
    [`@media (min-width: 2000px)`]: {
      fontSize: "2vh"
    },

    "& img": {
      width: "auto",
      height: "1rem",
      marginRight: "0.5rem",
      [`@media (min-width: 2000px)`]: {
        width: "2.5vh",
        height: "2.5vh",
     },
    },
  },

  "& .social-media-metrics": {
    "& > div": {
      display: "flex",
    },
  },
}));

export const CMMetricItem = styled.div((props) => ({
  display: "flex",
  justifyContent: "space-between",
  [`@media (min-width: 2000px)`]: {
    height:"3vh",
    alignItems:"center"
  },

  "& div": {
    textTransform: "capitalize",
    fontSize: "14px",
    lineHeight: "1.5rem",
    color: "#1d2b38",
    fontFamily: "Inter, sans-serif",
    marginTop:"5px",
    [`@media (min-width: 2000px)`]: {
      fontSize: "2vh",
    },

    "&.metric-value": {
      marginLeft: "2rem",
    },
  },

  "& span": {
    color: "#337ab7",
    marginLeft: "5px",
  },
}));

export const CMTracksPerformance = styled.div((props) => ({
  backgroundColor: "#f8f8f8",
  // padding: '40px 0',

  "& h4": {
    marginBottom: "1rem",
  },
}));


export const CMSocialImpactCharts = styled.div((props) => ({
  display: 'flex',
  placeContent: 'center',
  alignItems: 'center',
  gap: '10px',
  flexWrap: 'wrap'
}));

export const CMCards = styled.div((props) => ({
  display: 'flex',
  placeContent: 'center',
  flexWrap: 'wrap'
}));


export const CMTrackSocialCharts = styled.div((props) => ({
  display: 'flex',
  placeContent: 'center',
  gap: '2px',
  flexWrap: 'wrap'
}));